import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      marginTop: "5%",
    },
    "& .MuiBreadcrumbs-separator": {
      marginLeft: 2,
      marginRight: 2,
    },
    "& .bread-crumb:hover": {
      textDecoration: "none",
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      padding: "4px",
      borderRadius: "5px",
    },
  },
  crumbLink: {
    display: "inline-flex",
    alignItems: "center",
    minHeight: 24,
    minWidth: 24,
    padding: "2px 4px",
    margin: "0 2px",
    borderRadius: 4,
    cursor: "pointer",
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 1,
    },
  },
  homeLinkSpan: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "30px",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      marginLeft: "0",
    },
  },
  homeArrow: {
    fontSize: "1.25rem",
    transform: "rotate(180deg) translate(25%, 30%)",
  },
  homeTypo: {
    fontSize: "11px",
    color: theme.palette.grey["800"],
    textTransform: "none",
    [theme.breakpoints.down("md")]: {
      fontSize: "8px",
    },
  },
  otherlinkTypo: {
    maxWidth: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "11px",
    color: theme.palette.grey["800"],
    paddingLeft: 2,
    paddingRight: 2,
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      fontSize: "8px",
    },
  },
}));
